(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eme-menu-random"] && !Shopify.designMode) return;
  try {
    class EmeMenuRandom extends HTMLElement {
  connectedCallback() {
    this.observer?.disconnect();
    if (this.dataset.ready !== 'true') this.shuffle();
    this.observer = new MutationObserver(() => {
      if (this.dataset.ready !== 'true') this.shuffle();
    });
    this.observer.observe(this, { attributes: true, attributeFilter: ['data-ready'], childList: true });
  }
  shuffle() {
    const pool = [...this.querySelectorAll('template[data-random-product]')];
    for (let i = pool.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [pool[i], pool[j]] = [pool[j], pool[i]];
    }
    const target = this.querySelector('[data-random-cards]');
    if (target && pool.length) target.replaceChildren(...pool.slice(0, 2).map(t => t.content.cloneNode(true)));
    this.dataset.ready = 'true';
  }
  disconnectedCallback() { this.observer?.disconnect(); }
}
if (!customElements.get('eme-menu-random')) customElements.define('eme-menu-random', EmeMenuRandom);
  } catch(e) { console.error(e); }
})();

})();
